import { render } from "./ClientPanel.vue?vue&type=template&id=01d01147"
import script from "./ClientPanel.vue?vue&type=script&lang=js"
export * from "./ClientPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__